import { NSARouterMakerResult } from "namirasoft-account-react";
import { NSMenuActionProps } from "namirasoft-site-react";
import { ErpRouterProps } from "./ErpRouterProps";
import { ErpRoutes } from "./ErpRoutes";
import { ErpScope } from "./ErpScope";

export class FiscalYearMenus
{
    static open(props: NSARouterMakerResult & ErpRouterProps, getIDs: () => string[], getRows: () => { id: string }[]): NSMenuActionProps
    {
        return {
            id: "fy-open",
            menu_item: "Open",
            isActive: () =>
            {
                let rows = getRows();
                if (rows.length !== 1)
                    return false;
                return true;
            },
            onClick: {
                action: async (onFinished) =>
                {
                    try
                    {
                        let id = getIDs()[0];
                        let branch_id = ErpScope.getBranchId();
                        let je = await props.servers.erp.fiscal_year.Open(id, { branch_id });
                        props.url.redirect(ErpRoutes.JournalEntryView(je.id), {});
                    }
                    catch (err)
                    {
                    }
                    finally
                    {
                        onFinished();
                    }
                },
                showLoading: true
            }
        };
    }
    static close(props: NSARouterMakerResult & ErpRouterProps, getIDs: () => string[], getRows: () => { id: string }[]): NSMenuActionProps
    {
        return {
            id: "fy-close",
            menu_item: "Close",
            isActive: () =>
            {
                let rows = getRows();
                if (rows.length !== 1)
                    return false;
                return true;
            },
            onClick: {
                action: async (onFinished) =>
                {
                    try
                    {
                        let id = getIDs()[0];
                        let branch_id = ErpScope.getBranchId();
                        let je = await props.servers.erp.fiscal_year.Close(id, { branch_id });
                        props.url.redirect(ErpRoutes.JournalEntryView(je.id), {});
                    }
                    catch (err)
                    {
                    }
                    finally
                    {
                        onFinished();
                    }
                },
                showLoading: true
            }
        };
    }
    static unopen(props: NSARouterMakerResult & ErpRouterProps, getIDs: () => string[], getRows: () => { id: string }[], reload: () => void): NSMenuActionProps
    {
        return {
            id: "fy-unopen",
            menu_item: "Unopen",
            isActive: () =>
            {
                let rows = getRows();
                if (rows.length !== 1)
                    return false;
                return true;
            },
            onClick: {
                action: async (onFinished) =>
                {
                    try
                    {
                        let id = getIDs()[0];
                        let branch_id = ErpScope.getBranchId();
                        await props.servers.erp.fiscal_year.Unopen(id, { branch_id });
                        reload();
                    }
                    catch (err)
                    {
                    }
                    finally
                    {
                        onFinished();
                    }
                },
                showLoading: true
            }
        };
    }
    static unclose(props: NSARouterMakerResult & ErpRouterProps, getIDs: () => string[], getRows: () => { id: string }[], reload: () => void): NSMenuActionProps
    {
        return {
            id: "fy-unclose",
            menu_item: "Unclose",
            isActive: () =>
            {
                let rows = getRows();
                if (rows.length !== 1)
                    return false;
                return true;
            },
            onClick: {
                action: async (onFinished) =>
                {
                    try
                    {
                        let id = getIDs()[0];
                        let branch_id = ErpScope.getBranchId();
                        await props.servers.erp.fiscal_year.Unclose(id, { branch_id });
                        reload();
                    }
                    catch (err)
                    {
                    }
                    finally
                    {
                        onFinished();
                    }
                },
                showLoading: true
            }
        };
    }
}